import { z } from 'zod'
import type { useI18n } from 'vue-i18n'

// Infer the translation function type from useI18n
type I18nComposer = ReturnType<typeof useI18n>
type TranslationFunction = I18nComposer['t']

export const createEmailSchema = (t: TranslationFunction) =>
  z.object({
    email: z.string().email(t('login.validation.email', { email: 'email' })),
  })

export const createLoginSchema = (t: TranslationFunction) =>
  createEmailSchema(t).extend({
    password: z.string().min(8, t('login.validation.min', { min: 8 })),
  })

export const createGuestSchema = (t: TranslationFunction) =>
  createEmailSchema(t).extend({
    first_name: z.string().min(1, t('login.validation.required')),
    last_name: z.string().min(1, t('login.validation.required')),
    company_name: z.string(),
    phone: z
      .string()
      .refine((val) => !val || (val.length >= 6 && val.length <= 15), {
        message: t('checkout.personalDetails.validation.phone.min', { min: 6 }),
      }),
    newsletter: z.boolean(),
  })

export const createRegisterSchema = (t: TranslationFunction) =>
  createLoginSchema(t).extend({
    first_name: z.string().min(1, t('login.validation.required')),
    last_name: z.string().min(1, t('login.validation.required')),
    company_name: z.string(),
    phone: z
      .string()
      .refine((val) => !val || (val.length >= 6 && val.length <= 15), {
        message: t('checkout.personalDetails.validation.phone.min', { min: 6 }),
      }),
    newsletter: z.boolean(),
  })

export type EmailFormData = z.infer<ReturnType<typeof createEmailSchema>>
export type LoginFormData = z.infer<ReturnType<typeof createLoginSchema>>
export type RegisterFormData = z.infer<ReturnType<typeof createRegisterSchema>>
